import { CurrentRfqStatusThemeSizeConfig } from './types';

const small: CurrentRfqStatusThemeSizeConfig = {
  currentRfqStatus: {},
};

export default small;
